export default "__VITE_ASSET__56bd4517__"